/*
 * InSight Analytics Solutions Limited
 * https://fieldpro.onyxinsight.com/
 *
 * Copyright (c) 2021 Onyx InSight Field Pro.
 * This file is licensed to InSight Analytics Solutions Limited
 */
const initialState = {
  datatablelist: '',
  addcustomerresult: null,
  customereditresult: null,
  userprefencelist: null,
  isReload: false,
  datatableColumnChooser: null,
};

const datatableReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case ' datatablelist':
      return {
        ...state,
        datatablelist: action.value,
      };
    case 'addcustomer':
      return {
        ...state,
        addcustomerresult: action.value,
        isReload: true,
      };
    case 'customereditdata':
      return {
        ...state,
        customereditresult: action.value,
        isReload: true,
      };
    case 'validmail':
      return {
        ...state,
        isEmailValid: action.value,
      };
    case 'userprefencelist':
      return {
        ...state,
        userprefencelist: action.value,
      };
    case 'DATATABLE_COLUMN_CHOOSER':
      return {
        ...state,
        datatableColumnChooser: action.value,
      };
    default:
      return state;
  }
};

export default datatableReducer;
